const state = {
  token: '',
  userInfo: {
    type: null,
    displayName: '',
    mobile: null,
    lastIP: '',
    lastLoginTime: '',
    permissonNames: [],
    profilePhoto: ''
  },
  guarantorInfo: {
    name: null,
    id: null
  },
  supervisorInfo: {
    id: null,
    name: null
  },
  smsVerifierCbFn: null,
  smsVerifierCbArgs: null,
  smsVerifyCode: null
}
const mutations = {
  LOGOUT (state) {
    state.token = null
    state.userInfo = {
      type: null,
      displayName: '',
      mobile: null,
      lastIP: '',
      lastLoginTime: '',
      permissonNames: [],
      profilePhoto: ''
    }
    state.guarantorInfo = {
      name: null,
      id: null
    }
    state.supervisorInfo = {
      name: null,
      id: null
    }
    window.localStorage.setItem('token', null)
    window.localStorage.setItem('userInfo', null)
    window.localStorage.setItem('guarantor-info', null)
    window.localStorage.setItem('supervisor-info', null)
    window.localStorage.setItem('view-mode', null)
  },
  SET_TOKEN (state, data) {
    state.token = data
  },
  SET_USER_MOBILE (state, data) {
    state.userInfo.mobile = data
  },
  SET_USERINFO (state, data) {
    state.guarantorInfo = {
      name: null,
      id: null
    }
    window.localStorage.setItem('guarantor-info', null)
    state.supervisorInfo = {
      name: null,
      id: null
    }
    window.localStorage.setItem('supervisor-info', null)
    Object.assign(state.userInfo, data)
  },
  SET_GUARANTORINFO (state, data) {
    Object.assign(state.guarantorInfo, data)
  },
  SET_SUPERVISORINFO (state, data) {
    Object.assign(state.supervisorInfo, data)
  },
  SET_SMSVERIFIER_CALLBACK_FN (state, data) {
    state.smsVerifierCbFn = data
  },
  SET_SMSVERIFIER_CALLBACK_ARGS (state, data) {
    state.smsVerifierCbArgs = data
  },
  SET_SMSVERIFY_CODE (state, data) {
    state.smsVerifyCode = data
  },
  CLEAR_SMSVERIFY_INFO (state) {
    state.smsVerifierCbArgs = null
    state.smsVerifierCbFn = null
    state.smsVerifyCode = null
  }
}
const actions = {
  logout ({ commit }) {
    commit('LOGOUT')
  },
  setToken ({ commit }, data) {
    commit('SET_TOKEN', data)
  },
  setUserMobile ({ commit }, data) {
    commit('SET_USER_MOBILE', data)
  },
  setUserInfo ({ commit }, data) {
    commit('SET_USERINFO', data)
  },
  setGuarantorInfo ({ commit }, data) {
    commit('SET_GUARANTORINFO', data)
  },
  setSupervisorInfo ({ commit }, data) {
    commit('SET_SUPERVISORINFO', data)
  },
  setSmsVerifierCallbackFn ({ commit }, data) {
    commit('SET_SMSVERIFIER_CALLBACK_FN', data)
  },
  setSmsVerifierCallbackArgs ({ commit }, data) {
    commit('SET_SMSVERIFIER_CALLBACK_ARGS', data)
  },
  setSmsVerifyCode ({ commit }, data) {
    commit('SET_SMSVERIFY_CODE', data)
  },
  clearSmsVerifyInfo ({ commit }, data) {
    commit('CLEAR_SMSVERIFY_INFO', data)
  }
}
const getters = {
  token: state => {
    return state.token
  },
  userInfo: state => {
    let localStorageUserInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    if (state.userInfo && state.userInfo.displayName) {
      return state.userInfo
    } else {
      return localStorageUserInfo
    }
  },
  guarantorInfo: state => {
    let localStorageGuarantorInfo = JSON.parse(window.localStorage.getItem('guarantor-info'))
    if (state.guarantorInfo && state.guarantorInfo.name) {
      return state.guarantorInfo
    } else {
      return localStorageGuarantorInfo
    }
  },
  supervisorInfo: state => {
    let localStorageSupervisorInfo = JSON.parse(window.localStorage.getItem('supervisor-info'))
    if (state.supervisorInfo && state.supervisorInfo.name) {
      return state.supervisorInfo
    } else {
      return localStorageSupervisorInfo
    }
  },
  smsVerifierCbFn: state => {
    return state.smsVerifierCbFn
  },
  smsVerifierCbArgs: state => {
    return state.smsVerifierCbArgs
  },
  smsVerifyCode: state => {
    return state.smsVerifyCode
  }
}
 
// 不要忘记把state, mutations等暴露出去。
export default {
  state,
  mutations,
  actions,
  getters
}